import React from "react";
import { Formik } from "formik";
import { TextField, Paper, withStyles, Button, Typography, CircularProgress } from "@material-ui/core";
import * as Yup from "yup";
import { BackButton } from '../../../sc-utilities';

const styles = theme => ({
    root: {
        width: "auto",
        height: "auto",
        padding: theme.spacing(2),
        margin: theme.spacing(2)
    },
    submit: {
        textTransform: 'none',
        color: theme.palette.buttonText.default,
        backgroundColor: theme.palette.primary.main,
        borderRadius: '1px',
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
        },
        width: "100%",
        marginTop: "10px"
    },
    formControl: {
        width: "100%"
    }
});

const ContactForm = props => {
    const { classes, formSettings, initialValues, handleSubmit, translations } = props;
    return (
        <Paper className={classes.root}>
            {BackButton(translations)}
            <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                enableReinitialize={true}
                validationSchema={Yup.object().shape(formSettings.Validation)}
            >
                {formikProps => {
                    const { values, touched, errors, isValid, dirty, isSubmitting, handleChange, handleBlur, handleSubmit } = formikProps;
                    return (
                        <form onSubmit={handleSubmit}>
                            <Typography variant={"h6"}>{formSettings.FormTitle ? formSettings.FormTitle : null}</Typography>
                            <TextField
                                name="FirstName"
                                value={values.FirstName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.FirstName && touched.FirstName)}
                                placeholder={translations['first_name'] || 'First Name'}
                                label={translations['first_name'] || 'First Name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="LastName"
                                value={values.LastName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.LastName && touched.LastName)}
                                placeholder={translations['last_name'] || 'Last name'}
                                label={translations['last_name'] || 'Last name'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="CompanyName"
                                value={values.CompanyName}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.CompanyName && touched.CompanyName)}
                                placeholder={translations['company_name'] || 'CompanyName'}
                                label={translations['company_name'] || 'CompanyName'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="PhoneNumber"
                                value={values.PhoneNumber}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                error={!!(errors.PhoneNumber && touched.PhoneNumber)}
                                placeholder={translations['phone_number'] || 'Phone number'}
                                label={translations['phone_number'] || 'Phone number'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <TextField
                                name="Email"
                                value={values.Email}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                type='email'
                                error={!!(errors.Email && touched.Email)}
                                placeholder={translations['email'] || 'Email'}
                                label={translations['email'] || 'Email'}
                                margin={"dense"}
                                fullWidth={true}
                            />
                            <div>
                                {formSettings.ButtonSubmit ? (
                                    <Button
                                        fullWidth={true}
                                        className={classes.submit}
                                        variant="contained"
                                        color={formSettings.ButtonSubmit.Color}
                                        type="submit"
                                        style={{ color: isSubmitting || !(isValid && dirty) ? null : 'white' }}
                                        disabled={isSubmitting || !(isValid && dirty)}
                                    >
                                        {isSubmitting ? <CircularProgress size={24} /> : formSettings.ButtonSubmit.Title}
                                    </Button>
                                ) : null}
                            </div>
                        </form>
                    );
                }}
            </Formik>
        </Paper>
    );
};
export default withStyles(styles, { withTheme: true })(ContactForm);
